import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ButtonContainer, ButtonWrapper, Button } from './SalonListCTA.style';
import Placeholder from '../../../components/Placeholder';

const SalonListCTA = ({ data, locale }) => (
  <ButtonContainer>
    {data && (
      <ButtonWrapper>
        <Link
          className="button"
          to={data.url && data.url !== '' ? `/${locale}${data.url}` : null}
          href={data.url && data.url !== '' ? `/${locale}${data.url}` : null}
          target={data.external ? '_blank' : null}
        >
          {data.label || <Placeholder w="50%" h="20px" />}
        </Link>
      </ButtonWrapper>
    )}
  </ButtonContainer>
);

SalonListCTA.defaultProps = {
  data: undefined,
  locale: undefined,
};

SalonListCTA.propTypes = {
  data: PropTypes.shape(),
  locale: PropTypes.string,
};

export default SalonListCTA;



// WEBPACK FOOTER //
// ./src/pages/RangePage/SalonListCTA/SalonListCTA.js